<div *ngIf="!isiFrame" class="footer-wrapper">
  <div class="footer-container">
    <div class="logo-section">
      <img
        class="intel-logo"
        src="/assets/brand/intel-logo-light.svg"
        alt="Intel Logo"
      />
    </div>
    <div class="content-section">
      <div class="links">
        <hyperkit-button
          routerLink="/customer-support"
          variant="link"
          color="secondary"
          text="Support"
        ></hyperkit-button>
        <hyperkit-button
          routerLink="/privacy-policy"
          variant="link"
          color="secondary"
          text="Privacy Policy"
        ></hyperkit-button>
        <hyperkit-button
          routerLink="/terms-and-conditions"
          variant="link"
          color="secondary"
          text="Terms and Conditions"
        ></hyperkit-button>
      </div>
      <div class="copyright">
        <hyperkit-typography variant="label1" color="primary">
          Copyright © {{ date }} Intel 471. All Rights Reserved
        </hyperkit-typography>
      </div>
    </div>
  </div>
</div>
